import {Controller} from "stimulus"
import AutoNumeric from "autonumeric";
import {cartIdFromPage, withValidCart} from "./cart_validity";
import {holdCardLine, releaseCardLine} from "./card_intent";

let autoNumericList = [];

let stripe, card

export default class extends Controller {

    connect() {
        console.log("log from cr-otc-cc controller");
        autoNumericList = new AutoNumeric.multiple([".surcharge-display", ".total-charge"], ['NorthAmerican', {unformatOnSubmit: true}]);
    }

    getChargeForm(e) {
        e.preventDefault();

        // Block if CC payment would create change due without sufficient cash
        var balanceEl = document.getElementById("balanceAmount");
        if (balanceEl) {
            var balance = makeNumber(balanceEl.innerText);
            if (balance < 0) {
                var cashInputs = document.querySelectorAll("[data-tender-type='cash']");
                var cashTotal = 0;
                for (var i = 0; i < cashInputs.length; i++) {
                    cashTotal += makeNumber(cashInputs[i].value || "0");
                }
                if (cashTotal < Math.abs(balance)) {
                    alert("Change can only be given from cash payments. Please reduce the credit card amount or add a cash payment to cover the change due.");
                    return;
                }
            }
        }

        console.log("get charge form from backend");
        const form = e.target.form;

        // Get the CSRF token from the meta tag
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        // The intent the server is about to create is fixed at the total showing
        // now, so the cart is the gateway's from this moment rather than from
        // when the client secret lands, and the amount is frozen for the whole
        // window. Handed back if nothing is created: a stale cart is refused
        // before the request goes, and a request that fails leaves no intent
        // behind it.
        const committedFields = e.target.closest(".cc-manual-fields");
        holdCardLine(committedFields);

        // Confirm the cart is still checkout-able before requesting a charge
        withValidCart(cartIdFromPage(), function () {
            // Built here rather than before the check: whatever the form carries
            // when the request actually goes is what the server is asked to
            // hold, so the page and the gateway cannot disagree about it.
            const formData = new FormData(form);
            // Submit the form using Fetch API
            fetch(form.action, {
                method: form.method,
                body: formData,
                headers: {
                    'X-CSRF-Token': csrfToken,
                    'Accept': 'application/json',
                },
                credentials: 'same-origin',
            })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(data => {
                            throw new Error(data.errors || 'Unknown error occurred');
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    document.querySelector(".stripe-payment-form-area").innerHTML = data.html;
                    document.querySelector(".card-detail-button").classList.add('hidden');
                    e.target.closest(".cc-manual-fields").querySelector("#cr_cc_otc_keyed_payment_amount_tendered").disabled = true;
                    stripe = Stripe(e.target.closest(".cc-manual-fields").querySelector("#stripe-api-key").value);
                    var elements = stripe.elements();
                    var style = {
                        base: {
                            color: "#32325d",
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: '24px',
                            backgroundColor: '#f7fbfd'
                        }
                    };

                    card = elements.create("card", {style: style});
                    card.mount(e.target.closest(".cc-manual-fields").querySelector("#card-element"));
                    card.addEventListener('change', function (event) {
                        var displayError = document.getElementById('card-errors');
                        if (event.error) {
                            displayError.textContent = event.error.message;
                            document.getElementById('stripe-submit').disabled = true;
                        } else {
                            displayError.textContent = '';
                            document.getElementById('stripe-submit').disabled = false;
                        }
                    });
                })
                .catch(error => {
                    releaseCardLine(committedFields);
                    console.error('Error during form submission:', error);
                    alert('Failed to set card payment. Please try again.');
                });
        }, function () {
            releaseCardLine(committedFields);
        });

    }


    submitPayment(ev) {
        console.log("submitting to Stripe");
        ev.target.closest(".cc-manual-fields").querySelector("#cancelled").value = "false";
        ev.target.closest(".cc-manual-fields").querySelector("#stripe-submit").disabled = true;
        const clientSecret = ev.target.closest(".cc-manual-fields").querySelector('#stripe-key').value;
        const resultsArea = ev.target.closest(".cc-manual-fields").querySelector(".stripe-result")
        const ccFields = ev.target.closest(".cc-manual-fields");
        ev.preventDefault();
        // Confirm the cart is still checkout-able before charging the card
        withValidCart(cartIdFromPage(), function () {
            stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: card,
                }
            }).then(function (result) {
                if (result.error) {
                    // Show error to your customer (e.g., insufficient funds)
                    console.log(result.error.message);
                    resultsArea.innerHTML = "<p class=\"alert\">" + result.error.message + "</p>";
                    ccFields.querySelector(".ready-to-pay").innerText = "false";
                    ccFields.querySelector("#cancelled").value = "true";
                    ccFields.querySelector("#stripe-submit").disabled = false;
                } else {
                    // The payment has been processed!
                    console.log("payment succeeded")
                    if (result.paymentIntent.status === 'succeeded') {
                        resultsArea.innerHTML = "<p class=\"notice\"> Payment Successful</p>";
                        document.querySelector("#stripe-submit").classList.add('hidden');
                        ccFields.querySelector(".stripe-payment-form-area").classList.add('hidden');
                        ccFields.querySelector(".ready-to-pay").innerText = "true";
                        ccFields.querySelector("#cr_cc_otc_keyed_payment_reference").value = result.paymentIntent.id;
                    }
                }
            });
        }, function () {
            // Stop the pending-payment polling loop on a stale cart
            ccFields.querySelector("#cancelled").value = "true";
        });
        return false;
    }

    updateChargeAmount(e) {
        console.log("Charge Amount updated, updating surcharge");
        const surchargeDisplay = e.target.closest(".cc-manual-fields").querySelector(".surcharge-display");
        const totalDisplay = e.target.closest(".cc-manual-fields").querySelector(".total-charge");
        const base = makeNumber(e.target.closest(".cc-manual-fields").querySelector("#cr_cc_otc_keyed_payment_surcharge_base").value);
        const rate = makeNumber(e.target.closest(".cc-manual-fields").querySelector("#cr_cc_otc_keyed_payment_surcharge_rate").value);
        const newAmountTendered = makeNumber(e.target.closest(".cc-manual-fields").querySelector("#cr_cc_otc_keyed_payment_amount_tendered").value);
        const newSurcharge = Math.round((newAmountTendered * (rate) + base) * 100) / 100;
        const newTotal = Math.round((newAmountTendered * (1 + rate) + base) * 100) / 100;
        surchargeDisplay.innerText = newSurcharge;
        totalDisplay.innerText = newTotal;
        autoNumericList.reformat;
    }

}

function makeNumber(textVal) {
    return Number(textVal.replace(/[$,]/g, "").trim());
}